import { Deserializable } from './deserializable';

export class CrashError implements Deserializable {

  message: string;
  url: string;

  constructor() {
  }

  deserialize(input: any) {

    Object.assign(this, input);
    return this;
  }

}
